import { Component} from '@angular/core';
import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-home-four',
  templateUrl: './home-four.component.html',
  styleUrl: './home-four.component.css'
})
export class HomeFourComponent {
  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  // Funfacts
  funFacts =[
    {
      number: 111,
      desc: "Projects Won",
      displayedNumber: 0
    },
    {
      number: 74,
      desc: "Cups of Coffee",
      displayedNumber: 0
    },
    {
      number: 500,
      desc: "Statisfy Clients",
      displayedNumber: 0
    },
    {
      number: 34,
      desc: "Awwwards",
      displayedNumber: 0
    }
  ];

  ngOnInit(): void {
      this.startCounters();
    }
  
    startCounters(): void {
      this.funFacts.forEach(fact => {
        this.animateCounter(fact);
      });
    }
  
    animateCounter(fact: any): void {
      const duration = 4000; 
      const intervalTime = 50; 
      const increment = fact.number / (duration / intervalTime);
  
      const interval = setInterval(() => {
        fact.displayedNumber += increment;
        if (fact.displayedNumber >= fact.number) {
          fact.displayedNumber = fact.number;
          clearInterval(interval); 
        }
      }, intervalTime);
    }

  // Team Member
  teams =[
    {
      img:'team-1.jpg',
      name:'Bryan Smith',
      designation:'CEO/Founder'
    },
    {
      img:'team-2.jpg',
      name:'Tina Smith',
      designation:'Designer'
    },
    {
      img:'team-3.jpg',
      name:'Bob Ddo',
      designation:'Developer'
    }
  ];

  socialMedia =[
    {icon:'fa-behance'},
    {icon:'fa-dribbble'},
    {icon:'fa-x-twitter'}
  ];
  
  //Works
  works=[
    {
      img:'gallery-1.jpg',
      name:'Digital Food',
      category:'Branding'
    },
    {
      img:'gallery-3.jpg',
      name:'Poster',
      category:'UX/UX Design'
    },
    {
      img:'gallery-4.jpg',
      name:'Blue Berry',
      category:'Media'
    },
    {
      img:'gallery-11.jpg',
      name:'Death Proof',
      category:'UX Design/Media'
    },
    {
      img:'gallery-12.jpg',
      name:'3d Design',
      category:'Media/Illustration'
    },
    {
      img:'gallery-13.jpg',
      name:'Muse + Metta',
      category:'Branding'
    }
  ];

  //Pricing Plans
  pricingPlans = [
    {
      icon: 'bi-cup',
      title: 'Startup',
      description: 'Perfect for small startups that have less than 10 team members',
      price: 19,
      features: [
        '1 GB of space',
        'Support at $25/hour',
        'Small social media package'
      ]
    },
    {
      icon: 'bi-gem',
      title: 'Business',
      description: 'Ideal for growing businesses needing more storage and support',
      price: 49,
      features: [
        '10 GB of space',
        'Support at $15/hour',
        'Standard social media package'
      ]
    },
    {
      icon: 'bi-rocket',
      title: 'Enterprise',
      description: 'Best for large organizations with custom needs',
      price: 99,
      features: [
        'Unlimited space',
        'Free support',
        'Full social media management'
      ]
    }
  ];

//Services
services = [
  {
    icon:'bi-brush',
    title:'Branding',
    desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua'
  },
  {
    icon:'bi-airplane',
    title:'Typography',
    desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua'
  },
  {
    icon:'bi-camera',
    title:'Advertising',
    desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua'
  },
  {
    icon:'bi-gear',
    title:'Easy Customize',
    desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua'
  },
  {
    icon:'bi-bootstrap',
    title:'Bootstrap 5x',
    desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua'
  },
  {
    icon:'bi-phone',
    title:'Responsive',
    desc:'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua'
  }
];

// OWl Testimonials
customOptions: OwlOptions = {
  loop: true,
  dots: true,
  margin:0,
  nav:true,
  autoplay:true,
  autoplaySpeed: 2000,
  navSpeed: 2000,
  items: 1,
  navText: ['<i class="bi bi-arrow-left-short"></i>', '<i class="bi bi-arrow-right-short"></i>'],
}

slideStore = [
  {
    img: "client-1-md.jpg",
    name: "Jazz Smith",
    designation: "Manager",
    desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
  },
  {
    img: "client-2-md.jpg",
    name: "Shawn Palmer",
    designation: "Developer",
    desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
  },
  {
    img: "client-3-md.jpg",
    name: "Susan Mullen",
    designation: "Designer",
    desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
  }

]

//Blogs
blogs =[
    {
      img:'blog-1.jpg',
      title:'Batman V Superman',
      desc:'Proin metus diam, euismod a enim ac, gravida sodales mi.',
      date:'FEBRUARY 27, 2025',
      comments:'6 Comments'
    },
    {
      img:'blog-3.jpg',
      title:'Art Direction',
      desc:'Proin metus diam, euismod a enim ac, gravida sodales mi.',
      date:'JUNE 24, 2025',
      comments:'5 Comments'
    },
    {
      img:'blog-4.jpg',
      title:'Design Scene',
      desc:'Proin metus diam, euismod a enim ac, gravida sodales mi.',
      date:'JULY 30, 2023',
      comments:'28 Comments'
    }
  ];

  // Contact Form
  formData = {
    user_name: '',
    user_email: '',
    message: ''
  };

  // EmailJS service configuration
  private serviceId = 'helifax-form';  // Replace with your EmailJS Service ID
  private templateId = 'helifax-form';  // Replace with your EmailJS Template ID
  private publicKey = 'dOfh1ImCGDZCO9GJb';  // Replace with your EmailJS Public Key

  // Method to send email on form submission
  public sendEmail(event: Event): void {
    event.preventDefault();

    // Send email using EmailJS
    emailjs.sendForm(this.serviceId, this.templateId, event.target as HTMLFormElement, this.publicKey)
      .then(
        (response: EmailJSResponseStatus) => {
          alert('Message sent successfully. Thank you, we will get back to you soon!');
          this.resetForm();
        },
        (error: EmailJSResponseStatus) => {
          console.error('Failed to send message. Error:', error.text);
          alert('Failed to send the message. Please try again later.');
        }
      );
  }

  // Method to reset the form after submission
  private resetForm(): void {
    this.formData = {
      user_name: '',
      user_email: '',
      message: ''
    };
  }
}
